import { render, staticRenderFns } from "./MessageBoardPage.vue?vue&type=template&id=38d0a938&scoped=true"
import script from "./MessageBoardPage.vue?vue&type=script&lang=js"
export * from "./MessageBoardPage.vue?vue&type=script&lang=js"
import style0 from "./MessageBoardPage.vue?vue&type=style&index=0&id=38d0a938&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0a938",
  null
  
)

export default component.exports